/**
 * Controls the progress a div has reached a destination via scroll
 * Used for scroll transitions as the main function to use is getting
 * the scrollProgress which will allow things to transition from 0->1 state
 */
import throttle from 'lodash.throttle'
const COMPLETE_SCROLL_PERCENTAGE = 0.3
const THROTTLE_SPEED = 100
export default class ScrollTransitionController {

  /**
   * Constructs a new ScrollTransitionController
   * @param {Object} refs the reference to the components refs
   * @param {String} ref the name of the ref
   * @param {Object} options the options to pass
   * @param {Number} options.completeScrollPercentage how far up from the bottom the scroll considers 100%
   * @param {String} options.anchor which point of the div we reference for position ('top'/'bottom'/'center')
   */
  constructor(refs, ref, options) {
    options = options || {}
    // have to wrap or loses context to this
    this.throttle = throttle(() => { this.onScroll() }, THROTTLE_SPEED)
    window.addEventListener("scroll", this.throttle)
    setTimeout(() => { this.onScroll() }, 100)
    this._scrollProgress = 0
    this.completeScrollPercentage = options.completeScrollPercentage || COMPLETE_SCROLL_PERCENTAGE
    this.anchor = options.anchor || 'top'
    this.windowHeight = window.innerHeight,
      this.refs = refs
    this.ref = ref
  }

  /**
   * Gets a percentage of how much the element has scrolled
   * 0 - Bottom of the screen
   * 100 - At {completeScrollPercentage}% of the screen
   */
  get scrollProgress() {
    let val = (1 - this._scrollProgress) * (1 / this.completeScrollPercentage)
    return Math.min(1, Math.max(0, val))
  }

  /**
   * Gets the reference of the $el this controller looks at
   */
  _getRef() {
    return this.refs[this.ref]
  }

  /**
   * Fired on scroll
   */
  onScroll() {
    let el = this._getRef()
    if (!el) return
    let rect = el.getBoundingClientRect()
    let textScroll = 0
    if (this.anchor === 'center') {
      textScroll = (rect.top + rect.bottom) / 2
    } else {
      textScroll = rect[this.anchor]
    }
    // distance from top of element to middle of screen
    this._scrollProgress = Math.max(
      0,
      Math.min(1, textScroll / this.windowHeight)
    )
  }

  /**
   * Clears everything
   */
  destroy() {
    this.throttle.cancel()
    window.removeEventListener("scroll", this.throttle)
  }

}